import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
export function CookiebeleidPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-1035">
      <SEO title="Cookiebeleid | Noord Digital" description="Lees het cookiebeleid van Noord Digital. Wij informeren je over het gebruik van cookies op onze website." data-id="element-1036" />
      <Header data-id="element-1037" />

      <main className="pt-32 pb-20" data-id="element-1038">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[900px]" data-id="element-1039">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-[#111827]" data-id="element-1040">
            Cookiebeleid
          </h1>
          <p className="text-gray-500 italic mb-12" data-id="element-1041">
            Dit cookiebeleid is voor het laatst geüpdatet op 13 augustus, 2025
            en is van toepassing op burgers en wettelijke permanente inwoners
            van de Europese Economische Ruimte en Zwitserland.
          </p>

          <div className="prose prose-lg max-w-none prose-headings:text-[#111827] prose-a:text-[#007AFF] prose-p:text-[#6B7280] prose-li:text-[#6B7280]" data-id="element-1042">
            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1043">1. Introductie</h2>
            <p data-id="element-1044">
              Op onze site, https://noorddigital.nl (hierna: "de site") wordt
              gebruikgemaakt van cookies en andere aanverwante technieken.
              (Hierna geldt dat alle technieken voor het gemak "cookies" worden
              genoemd). Ook via derden die door ons zijn ingeschakeld, worden
              cookies geplaatst. In het onderstaande document informeren wij je
              over het gebruik van cookies op onze site.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1045">
              2. Wat zijn cookies?
            </h2>
            <p data-id="element-1046">
              Een cookie is een klein eenvoudig bestand dat samen met pagina's
              van deze site wordt verzonden en door je browser op de harde
              schijf van je computer of ander apparaat wordt opgeslagen. De
              daarin opgeslagen informatie kan tijdens een volgend bezoek terug
              worden gestuurd naar onze servers of naar de servers van de
              betreffende derde partijen.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1047">
              3. Wat zijn scripts?
            </h2>
            <p data-id="element-1048">
              Een script is een stukje programmacode dat wordt gebruikt om onze
              site goed te laten functioneren en interactief te maken. Deze code
              wordt uitgevoerd op onze server, of op je apparatuur.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1049">
              4. Wat is een web beacon?
            </h2>
            <p data-id="element-1050">
              Een web beacon (ook pixel tag) is een klein, onzichtbaar stukje
              tekst of afbeelding op een site dat gebruikt wordt om verkeer op
              een site in kaart te brengen. Om dit te doen worden er met behulp
              van web beacons verschillende gegevens van je opgeslagen.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1051">5. Cookies</h2>

            <h3 className="text-xl font-bold mt-8 mb-3" data-id="element-1052">
              5.1 Technische of functionele cookies
            </h3>
            <p data-id="element-1053">
              Sommige cookies zorgen ervoor dat bepaalde onderdelen van de site
              goed werken en dat je gebruikers voorkeuren bekend blijven. Door
              het plaatsen van functionele cookies zorgen wij ervoor dat je onze
              site makkelijker kunt bezoeken. Op deze manier hoef je
              bijvoorbeeld niet steeds opnieuw dezelfde informatie in te voeren
              bij een bezoek aan onze site en is het onder andere mogelijk dat
              de artikelen in je winkelwagen bewaard blijven tot dat je hebt
              afgerekend. Deze cookies mogen wij plaatsen zonder dat je hier
              toestemming voor geeft.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-3" data-id="element-1054">
              5.2 Statistieken cookies
            </h3>
            <p data-id="element-1055">
              Wij gebruiken statistieken cookies om de beleving voor onze
              gebruikers te optimaliseren. Wij krijgen door middel van
              statistieken cookies inzicht in het gebruik van onze site. Wij
              vragen je toestemming om statistieken cookies te plaatsen.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-3" data-id="element-1056">
              5.3 Marketing/Tracking cookies
            </h3>
            <p data-id="element-1057">
              Marketing/tracking cookies zijn cookies of enige andere vorm van
              lokale opslag, die worden gebruikt om gebruikersprofielen te maken
              met het doel om advertenties te tonen of om de gebruiker te volgen
              op deze of verschillende sites voor soortgelijke
              marketingdoeleinden.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-3" data-id="element-1058">5.4 Sociale media</h3>
            <p data-id="element-1059">
              Op onze site hebben wij inhoud van Instagram, LinkedIn en Facebook
              opgenomen om webpagina's te promoten (bijv. "vind ik leuk", "pin")
              of te delen (bijv. "tweet") op sociale netwerken zoals Instagram,
              LinkedIn en Facebook. Deze inhoud is ingesloten met code die is
              afgeleid van Instagram, LinkedIn en Facebook en plaatst cookies.
              Deze inhoud kan bepaalde informatie opslaan en verwerken voor
              gepersonaliseerde reclame.
            </p>
            <p data-id="element-1060">
              Lees de privacyverklaring van deze partijen door (welke regelmatig
              kunnen wijzigen) om te weten wat zij met je (persoons)gegevens
              doen die zij via deze cookies verwerken. De informatie die zij
              verzamelen, wordt zo veel mogelijk geanonimiseerd. Instagram,
              LinkedIn en Facebook zijn gevestigd in de Verenigde Staten.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1061">
              6. Geplaatste cookies
            </h2>

            <div className="space-y-8 mt-6" data-id="element-1062">
              {/* WordPress */}
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1063">
                <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-1064">
                  WordPress
                </h3>
                <p className="text-sm mb-4" data-id="element-1065">
                  <span className="font-semibold" data-id="element-1066">Doel:</span> Functional,
                  Functioneel
                </p>
                <p className="text-sm mb-4" data-id="element-1067">
                  We gebruiken WordPress voor website ontwikkeling.
                </p>
                <div className="overflow-x-auto" data-id="element-1068">
                  <table className="min-w-full text-sm text-left" data-id="element-1069">
                    <thead className="bg-gray-100 text-gray-700" data-id="element-1070">
                      <tr data-id="element-1071">
                        <th className="px-4 py-2 rounded-tl-lg" data-id="element-1072">Naam</th>
                        <th className="px-4 py-2" data-id="element-1073">Expiratie</th>
                        <th className="px-4 py-2 rounded-tr-lg" data-id="element-1074">Functie</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200" data-id="element-1075">
                      <tr data-id="element-1076">
                        <td className="px-4 py-2 font-mono" data-id="element-1077">
                          WP_PREFERENCES_USER_*
                        </td>
                        <td className="px-4 py-2" data-id="element-1078">persistent</td>
                        <td className="px-4 py-2" data-id="element-1079">Store user preferences</td>
                      </tr>
                      <tr data-id="element-1080">
                        <td className="px-4 py-2 font-mono" data-id="element-1081">wp-settings-*</td>
                        <td className="px-4 py-2" data-id="element-1082">persistent</td>
                        <td className="px-4 py-2" data-id="element-1083">Store user preferences</td>
                      </tr>
                      <tr data-id="element-1084">
                        <td className="px-4 py-2 font-mono" data-id="element-1085">
                          wp-settings-time-*
                        </td>
                        <td className="px-4 py-2" data-id="element-1086">1 year</td>
                        <td className="px-4 py-2" data-id="element-1087">Store user preferences</td>
                      </tr>
                      <tr data-id="element-1088">
                        <td className="px-4 py-2 font-mono" data-id="element-1089">
                          wordpress_test_cookie
                        </td>
                        <td className="px-4 py-2" data-id="element-1090">session</td>
                        <td className="px-4 py-2" data-id="element-1091">
                          Read if cookies can be placed
                        </td>
                      </tr>
                      <tr data-id="element-1092">
                        <td className="px-4 py-2 font-mono" data-id="element-1093">
                          wordpress_logged_in_*
                        </td>
                        <td className="px-4 py-2" data-id="element-1094">persistent</td>
                        <td className="px-4 py-2" data-id="element-1095">Store logged in users</td>
                      </tr>
                      <tr data-id="element-1096">
                        <td className="px-4 py-2 font-mono" data-id="element-1097">
                          wpEmojiSettingsSupports
                        </td>
                        <td className="px-4 py-2" data-id="element-1098">sessie</td>
                        <td className="px-4 py-2" data-id="element-1099">
                          Opslaan van browserspecificaties
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Elementor */}
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1100">
                <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-1101">
                  Elementor
                </h3>
                <p className="text-sm mb-4" data-id="element-1102">
                  <span className="font-semibold" data-id="element-1103">Doel:</span> Statistics
                  (anonymous)
                </p>
                <p className="text-sm mb-4" data-id="element-1104">
                  We gebruiken Elementor voor content creatie.
                </p>
                <div className="overflow-x-auto" data-id="element-1105">
                  <table className="min-w-full text-sm text-left" data-id="element-1106">
                    <thead className="bg-gray-100 text-gray-700" data-id="element-1107">
                      <tr data-id="element-1108">
                        <th className="px-4 py-2 rounded-tl-lg" data-id="element-1109">Naam</th>
                        <th className="px-4 py-2" data-id="element-1110">Expiratie</th>
                        <th className="px-4 py-2 rounded-tr-lg" data-id="element-1111">Functie</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200" data-id="element-1112">
                      <tr data-id="element-1113">
                        <td className="px-4 py-2 font-mono" data-id="element-1114">elementor</td>
                        <td className="px-4 py-2" data-id="element-1115">persistent</td>
                        <td className="px-4 py-2" data-id="element-1116">
                          Store performed actions on the website
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Google Analytics */}
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1117">
                <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-1118">
                  Google Analytics
                </h3>
                <p className="text-sm mb-4" data-id="element-1119">
                  <span className="font-semibold" data-id="element-1120">Doel:</span> Statistics
                </p>
                <p className="text-sm mb-4" data-id="element-1121">
                  We gebruiken Google Analytics voor website statistieken.
                </p>
                <div className="overflow-x-auto" data-id="element-1122">
                  <table className="min-w-full text-sm text-left" data-id="element-1123">
                    <thead className="bg-gray-100 text-gray-700" data-id="element-1124">
                      <tr data-id="element-1125">
                        <th className="px-4 py-2 rounded-tl-lg" data-id="element-1126">Naam</th>
                        <th className="px-4 py-2" data-id="element-1127">Expiratie</th>
                        <th className="px-4 py-2 rounded-tr-lg" data-id="element-1128">Functie</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200" data-id="element-1129">
                      <tr data-id="element-1130">
                        <td className="px-4 py-2 font-mono" data-id="element-1131">_ga</td>
                        <td className="px-4 py-2" data-id="element-1132">2 years</td>
                        <td className="px-4 py-2" data-id="element-1133">Store and count pageviews</td>
                      </tr>
                      <tr data-id="element-1134">
                        <td className="px-4 py-2 font-mono" data-id="element-1135">_ga_*</td>
                        <td className="px-4 py-2" data-id="element-1136">1 year</td>
                        <td className="px-4 py-2" data-id="element-1137">Store and count pageviews</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Other services summarized for brevity but maintaining structure */}
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1138">
                <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-1139">
                  Andere Diensten
                </h3>
                <p className="text-sm mb-4" data-id="element-1140">
                  Wij maken ook gebruik van cookies van de volgende diensten:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-sm" data-id="element-1141">
                  <li data-id="element-1142">
                    <strong data-id="element-1143">LiteSpeed:</strong> Voor website hosting en caching
                    (_lscache_vary)
                  </li>
                  <li data-id="element-1144">
                    <strong data-id="element-1145">Google reCAPTCHA:</strong> Voor spampreventie
                    (rc::a, rc::b, rc::c)
                  </li>
                  <li data-id="element-1146">
                    <strong data-id="element-1147">Google Maps:</strong> Voor het vertonen van kaarten
                  </li>
                  <li data-id="element-1148">
                    <strong data-id="element-1149">YouTube:</strong> Voor het tonen van video's (GPS,
                    VISITOR_INFO1_LIVE, YSC, PREF)
                  </li>
                  <li data-id="element-1150">
                    <strong data-id="element-1151">Facebook & LinkedIn:</strong> Voor social media
                    integratie en tracking
                  </li>
                  <li data-id="element-1152">
                    <strong data-id="element-1153">Diversen:</strong> Diverse functionele en
                    statistische cookies (waaronder cmplz_* voor cookie consent
                    beheer)
                  </li>
                </ul>
              </div>
            </div>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1154">7. Toestemming</h2>
            <p data-id="element-1155">
              Wanneer je onze site voor het eerst bezoekt, tonen wij een pop-up
              met uitleg over cookies. Zodra je klikt op 'Voorkeuren opslaan'
              geef je ons toestemming om de categorieën cookies en plugins te
              gebruiken die je hebt geselecteerd in de pop-up en welke zijn
              omschreven in het cookiebeleid. Je kunt via je browser het
              plaatsen van cookies uitschakelen, je moet er dan wel rekening mee
              houden dat onze site dan mogelijk niet meer optimaal werkt.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1156">
              8. Cookies in-/uitschakelen en verwijderen
            </h2>
            <p data-id="element-1157">
              Je kunt je internet browser gebruiken om cookies automatisch of
              handmatig te verwijderen. Je kunt ook aangeven dat bepaalde
              cookies niet geplaatst mogen worden. Een andere optie is om de
              instellingen van je internetbrowser zo aan te passen dat je iedere
              keer dat er een cookie wordt geplaatst een bericht ontvangt.
              Raadpleeg voor meer informatie over deze opties de instructies in
              de Hulp sectie van je browser.
            </p>
            <p data-id="element-1158">
              Let op: onze site werkt mogelijk niet optimaal als alle cookies
              zijn uitgeschakeld. Als je wel de cookies in je browser
              verwijdert, worden ze na je toestemming opnieuw geplaatst bij een
              nieuw bezoek aan onze site.
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1159">
              9. Je rechten met betrekking tot persoonsgegevens
            </h2>
            <p data-id="element-1160">
              Je hebt de volgende rechten met betrekking tot je
              persoonsgegevens:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-1161">
              <li data-id="element-1162">
                Je hebt het recht om te weten waarom je persoonsgegevens nodig
                zijn, wat ermee gebeurt en hoe lang ze worden bewaard.
              </li>
              <li data-id="element-1163">
                Recht op inzage: je kunt een verzoek indienen om inzage in de
                gegevens die we van je verwerken.
              </li>
              <li data-id="element-1164">
                Recht op rectificatie en aanvulling: je hebt het recht om je
                persoonlijke gegevens aan te vullen, te corrigeren, te
                verwijderen of te blokkeren wanneer je maar wilt.
              </li>
              <li data-id="element-1165">
                Als je ons toestemming geeft om je gegevens te verwerken, heb je
                het recht om die toestemming in te trekken en je persoonlijke
                gegevens te laten verwijderen.
              </li>
              <li data-id="element-1166">
                Recht om je gegevens over te dragen: je hebt het recht om al je
                persoonlijke gegevens op te vragen bij de
                verwerkingsverantwoordelijke en deze in hun geheel over te
                dragen aan een andere verwerkingsverantwoordelijke.
              </li>
              <li data-id="element-1167">
                Recht op bezwaar: je kan bezwaar maken tegen de verwerking van
                je gegevens. Wij komen hieraan tegemoet, tenzij er gegronde
                redenen voor verwerking zijn.
              </li>
            </ul>
            <p data-id="element-1168">
              Om deze rechten uit te oefenen, neem contact met ons op. Verwijs
              naar de contactgegevens onderaan dit cookiebeleid. Als je een
              klacht hebt over hoe we met je gegevens omgaan, horen we graag van
              je, maar je hebt ook het recht om een klacht in te dienen bij de
              toezichthoudende autoriteit (de Autoriteit Persoonsgegevens).
            </p>

            <h2 className="text-2xl font-bold mt-10 mb-4" data-id="element-1169">
              10. Contactinformatie
            </h2>
            <p data-id="element-1170">
              Voor vragen en/of opmerkingen met betrekking tot ons cookiebeleid
              en deze verklaring kun je contact met ons opnemen via de volgende
              contactinformatie:
            </p>

            <div className="bg-gray-50 p-6 rounded-xl border border-gray-100 mt-6" data-id="element-1171">
              <p className="font-semibold text-[#111827] mb-1" data-id="element-1172">Noord Digital</p>
              <p className="mb-1" data-id="element-1173">Nieuwestad 132C</p>
              <p className="mb-1" data-id="element-1174">8911 DA Leeuwarden</p>
              <p className="mb-1" data-id="element-1175">Nederland</p>
              <p className="mb-1" data-id="element-1176">
                Site:{' '}
                <a href="https://noorddigital.nl" data-id="element-1177">https://noorddigital.nl</a>
              </p>
              <p className="mb-1" data-id="element-1178">
                E-mail:{' '}
                <a href="mailto:info@noorddigital.nl" data-id="element-1179">info@noorddigital.nl</a>
              </p>
              <p className="mb-0" data-id="element-1180">
                Telefoonnummer: <a href="tel:+31857444047" data-id="element-1181">+31 85 744 4047</a>
              </p>
            </div>

            <p className="text-sm text-gray-500 mt-8 italic" data-id="element-1182">
              Dit Cookiebeleid is gesynchroniseerd met cookiedatabase.org op 10
              augustus, 2025.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-1183" />
    </div>;
}